import { render, staticRenderFns } from "./FileDownload.vue?vue&type=template&id=a91fb9f8&scoped=true"
import script from "./FileDownload.vue?vue&type=script&lang=js"
export * from "./FileDownload.vue?vue&type=script&lang=js"
import style0 from "./FileDownload.vue?vue&type=style&index=0&id=a91fb9f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91fb9f8",
  null
  
)

export default component.exports